import {
  Box,
  Card,
  CircularProgress,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Modal,
  Stack,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import { useState } from "react";
import moment from "moment";
import { SAVE_RECENTLY_INTERACT_USERS, SEND_TIMESHEETS } from "../../../constant/Apipath";
import ShareModule from "../../common/ShareModule";
import { Postrequestcall } from "../../../request/Postrequest";
import { useSelector } from "react-redux";
import { English } from "../../../constant/EnglishFallback";

export default function SendTimesheet({ 
  open, 
  onClose, 
  selectedTimesheets = [], 
  loginData, 
  onSendComplete 
}) {
  // Self-managed state (moved from context)
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [loading, setLoading] = useState(false);

  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.TimeSheet || {};
  const {
    TEXT_SEND_TIMESHEETS = English.TimeSheet.TEXT_SEND_TIMESHEETS,
    TEXT_TIMESHEETS_TO_SEND = English.TimeSheet.TEXT_TIMESHEETS_TO_SEND
  } = LanguageData || {};

  const handleSendTimeSheet = async () => {
    try {
      setLoading(true);
      
      if (selectedEmails.length === 0) {
        setLoading(false);
        return;
      }

      const timeSheetArray = selectedTimesheets.map((item) => item.id);
      const emailList = selectedEmails.map((item) => item.contactEmail);
      
      const sendTimeSheetObj = {
        Emails: emailList,
        TimeSheets: timeSheetArray,
        UserId: loginData?.userInformation?.UserId
      };

      // Send timesheets API call
      const sendTimeSheetResponse = await Postrequestcall(
        SEND_TIMESHEETS,
        sendTimeSheetObj,
        loginData?.accessToken
      );

      if (sendTimeSheetResponse?.data?.message === "OK") {
        // Save recently interacted users
        const interactionRequests = selectedEmails
          .filter((item) => item.contactId && item.contactId !== 0)
          .map((item) => ({
            UserId: Number(loginData?.userInformation?.UserId),
            ReturnRecordId: true,
            ReturnRecordError: true,
            SaveList: [
              {
                Id: 0,
                UserId: Number(loginData?.userInformation?.UserId),
                InteractUserId: item.contactId,
                ModifiedBy: Number(loginData?.userInformation?.UserId),
                fromScreen: "TimeSheet"
              }
            ]
          }));

        // Save interaction history
        if (interactionRequests.length > 0) {
          await Promise.all(
            interactionRequests.map((interactionObj) =>
              Postrequestcall(SAVE_RECENTLY_INTERACT_USERS, interactionObj, loginData?.accessToken)
            )
          );
        }

        // Notify parent component of successful send
        if (onSendComplete) {
          await onSendComplete();
        }

        handleClose();
      }
    } catch (error) {
      console.log("handleSendTimeSheet-> Error While Sending Timesheet: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    // Reset all local state
    setSelectedEmails([]);
    setLoading(false);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="user-modal-responsive">
        {/* ✅ FIXED: Show loading overlay during send operation */}
        {loading && (
          <Box 
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
              borderRadius: 1
            }}>
            <CircularProgress size={40} sx={{ color: "#3A75C4" }} />
          </Box>
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6">{TEXT_SEND_TIMESHEETS}</Typography>
          <Stack flexDirection={"row"}>
            <IconButton onClick={handleClose} disabled={loading}>
              <CloseIcon />
            </IconButton>
            
            {/* ✅ FIXED: Send button with loading spinner */}
            <IconButton
              color="primary"
              onClick={handleSendTimeSheet}
              disabled={loading || selectedEmails.length === 0}>
              {loading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <SendIcon />
              )}
            </IconButton>
          </Stack>
        </Box>

        <Box maxHeight={"560px"} overflow={"scroll"} sx={{ scrollbarWidth: "none" }}>
          <Stack spacing={2}>
            <ShareModule
              from="ShareTickets"
              setSelectedEmails={setSelectedEmails}
              selectedEmails={selectedEmails}
              disabled={loading}
            />
            
            <Stack spacing={1}>
              <Typography variant="body1">{TEXT_TIMESHEETS_TO_SEND}</Typography>
              <Divider />
            </Stack>
            
            <Box maxHeight={"300px"} overflow={"scroll"} sx={{ scrollbarWidth: "none" }}>
              <List disablePadding>
                <Stack gap={1}>
                  {selectedTimesheets?.map((item, index) => (
                    <Card
                      key={index.toString()}
                      className="pagelist-content"
                      sx={{ 
                        marginTop: "0px",
                        opacity: loading ? 0.6 : 1
                      }}>
                      <ListItem sx={{ m: 0 }} key={index.toString()} disablePadding>
                        <ListItemText
                          sx={{ pl: 2 }}
                          primary={moment(item?.timesheetDate).format("MMMM DD, YYYY")}
                          secondary={`${item?.noOfJobs} jobs, ${item?.totalHours} hrs`}
                        />
                      </ListItem>
                    </Card>
                  ))}
                </Stack>
              </List>
            </Box>
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
}
